<template>
<div class="header" >
  <div class="home-top hidden-sm-and-down" >
      <div  @click="goHome">
        <span>HOME</span>
        首页
      </div>
      <div @mouseenter="showMasters" @mouseleave="offList" ref="list">
        <span>List of Masters</span>
        大师列表
      </div>
      <div @click="goMuseum">
        <span>Millennium Chaoshan Art Museum</span>
        千年潮艺博物馆
      </div>
  </div>
  <div class="hover-list hidden-sm-and-down" :style="`left:${vleft}px;width:${vwidth}px;`" v-show="hover" @mouseenter="showMasters" @mouseleave="offList">
      <div v-for="(item, index) in artistList" :key="index"  @click="gotoUser(item.id)">{{item.name}}<span>{{item.content}}</span></div>
  </div>
  <div class="phone-top hidden-md-and-up" v-if="$route.name&&$route.name !='user'&&$route.name !='detail'"> 
        <div style="width:30px"></div>
      <div @click="goHome">
        <span>HOME</span>
        首页
      </div>
      <el-dropdown :hide-on-click="false" trigger="click"   @command="handleCommand" @visible-change="handleChange" ref="drop">
        <img src="../assets/H.png"  style="width:30px; height:30px" alt="">
        <el-dropdown-menu slot="dropdown" class="phone-list">
          <el-dropdown-item command="a">
            大师列表
          </el-dropdown-item>
          <el-dropdown-item command="b">
            千年潮艺博物馆
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
  </div>
  <div class="hover-list1 hidden-md-and-up" style="right:147px;width:50%;max-width:200px" v-show="show" >
      <div v-for="(item, index) in artistList" :key="index"  @click="gotoUser(item.id)">{{item.name}}<span>{{item.content}}</span></div>
  </div>
</div>
</template>

<script>
import {getArtistList} from "@/api/api.js"
export default {
    
    data(){
        return{
            vleft:0,
            vwidth:0,
            vright:0,
            hover:false,
            show:false,
            artistList:[]
        }
    },
    methods:{
        showMasters(){
            clearTimeout(this.timer)
            this.hover = true
        },
        offList(){
            this.timer = setTimeout(()=>{this.hover = false},300)
        },
        gotoUser(id){
            this.$router.push({ path: "/user/" + id });
            this.show = false
        },
        goHome(){
            this.$router.push({ path: "/" });
            this.show = false
        },
        goMuseum(){
          if(window.localStorage.getItem('state') !='0'){
            this.$router.push({ path: "/show/index" });
          }else{
            this.$message('暂未开放');
          }
          this.show = false
        },
        handleCommand(command){
          switch(command){
            case "a" :this.show = !this.show; break
            case "b" : this.show = false;this.goMuseum();break
          }
        },
        handleChange(flag){
          if(!flag){
            this.show = false
          }
        }
    },
    mounted(){
        getArtistList().then(res=>{
          this.artistList = res.data
        })
        console.log(this.$refs.list);

        this.vleft = this.$refs.list.offsetLeft
        this.vwidth = this.$refs.list.scrollWidth
      
        this.timer = null
        window.addEventListener('resize',()=>{
             this.vleft = this.$refs.list.offsetLeft
            this.vwidth = this.$refs.list.scrollWidth
        })
    },
    
}
</script>

<style scoped>
.header{
    width: 100%;
    position: relative;
}
.phone-top{
  width: 100%;
  height: 40px;
  font-size: 16px;
  box-sizing: border-box;
  padding: 0 20px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #4a4a4a;
}
.phone-top>div:nth-child(2)>span{
  font-size: 20px;
}
.home-top{
  display: flex;
  background-color: #4a4a4a;
  height: 75px;
  align-items: center;
  justify-content: center;
  font-family: pingfang;
}
.home-top > div {
  color: #fff;
  padding: 0 30px;
  border-right: 2px solid #fff;
  font-size: 13px;
  cursor: pointer;
}
.home-top > div >span {
  font-size: 24px;
  margin-right: 5px;
}

.phone-list>li{
  flex: 1;
  font-size: 12px
}
.phone-list>li>span{
  font-size: 16px;
}
.hover-list{
    position: absolute;
    box-sizing: border-box;
    top: 75px;
    background-color: #fff;
    color: #000;
    z-index: 999;
}
.hover-list > div {
  padding: 15px;
  cursor: pointer;
}
.hover-list>div>span {
    margin-left: 15px;
}
.hover-list1{
    position: absolute;
    box-sizing: border-box;
    top: 59px;
    padding: 0 20px;
    font-size: 12px;
    background-color: #fff;
    color: #000;
    z-index: 999;
    border-radius: 4px;
}
.hover-list1>div{
  height: 36px;
  line-height: 36px;
}
.hover-list1>div>span{
  margin-left: 15px;
}
.home-top > div:last-of-type {
  border: none;
}
</style>